import { z } from 'zod';

export const CheckRegistrationServiceRequestDtoScheme = z
  .object({
    cookieHeader: z.string().optional(),
    xPlatform: z.enum(['MUSINSA', '29CM']),
  })
  .describe('CheckRegistrationServiceRequestDtoScheme');

export const CheckRegistrationServiceResponseDtoScheme = z
  .object({
    isRegistered: z.boolean(),
    redirectPath: z.string(),
  })
  .describe('CheckRegistrationServiceResponseDtoScheme');

export type CheckRegistrationServiceRequest = z.infer<
  typeof CheckRegistrationServiceRequestDtoScheme
>;

export type CheckRegistrationServiceResponse = z.infer<
  typeof CheckRegistrationServiceResponseDtoScheme
>;
